import {useCallback, useEffect, useState} from 'react'
import storage from 'services/storage'
import {serverPhoneFormat} from 'services/utils/apiUtils'
import {useLoginMutation} from 'store/Store'
import moment from 'moment'

const useLogin = (onRequestSmsVerification) => {
    const [loginResponse, setLoginResponse] = useState()
    const [loginError, setLoginError] = useState()

    const [
        doLogin, // This is the mutation trigger
        {isLoading, error, data}, // This is the destructured mutation result
    ] = useLoginMutation()

    const clearLoginError = () => setLoginError(null)

    useEffect(() => {
        if (data?.access_token) {
            const {
                access_token,
                uFirstName,
                uLastName,
                uGender,
                aemail,
                aid,
                refresh_token,
            } = data
            storage.updateLoginCredentials({
                token: access_token,
                name: uFirstName + ' ' + uLastName,
                gender: uGender,
                username: aemail,
                userId: aid,
                expire: moment(data['.expires']).format(),
                refreshToken: refresh_token,
                tokenReceivedTimeStamp: Date.now(),
            })

            setLoginResponse(data)
        } else {
            setLoginError(data)
        }
    }, [data])

    useEffect(() => {
        if (error) {
            if (error?.data?.error === 'expired') {
                onRequestSmsVerification?.()
            } else if (error?.data?.error) {
                setLoginError(error?.data?.error_description)
            } else {
                setLoginError(error)
            }
        }
    }, [error, onRequestSmsVerification])

    const login = useCallback(
        (loginData, ulth) => {
            const {username, password} = loginData
            storage.updateLoginCredentials({ulth})

            doLogin({
                username: serverPhoneFormat(username),
                password,
            })
        },
        [doLogin]
    )

    return {
        isLoading,
        doLogin: login,
        loginResponse,
        loginError,
        clearLoginError,
    }
}

export default useLogin
